import { Attributes, LookupBase } from '@singularsystems/neo-core';
import ParticipantRulesConfigLookup from './ParticipantRulesConfigLookup';

export default class ParticipantModuleConfigLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.ChildObject(ParticipantRulesConfigLookup)
    public readonly participantRules: ParticipantRulesConfigLookup = new ParticipantRulesConfigLookup();

    // Client only properties / methods
}